// modules
import React from 'react';
// components
import SpotCell from '../SpotCell';
import StrikeTableCell from '../StrikeTableCell';
// typings
import { Props } from './typings';

const StrikeTableRow: React.FC<Props> = ({ price, rowType }) => {
  const isSpotPrice = rowType === 'spot';

  if (isSpotPrice) {
    return <SpotCell />;
  }

  return (
    <StrikeTableCell price={price} rowType={rowType} />
  );
};

export default StrikeTableRow;
